/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react'

import { Hero } from './components/Hero'
import { HowItWorks as HowItWorksView } from './components/HowItWorks'
import { WhyNooklyn } from './components/WhyNooklyn'
import { NewestFeature } from './components/NewestFeature'
import { WhoNooklynFor } from './components/WhoNooklynFor'
import { WeWereFeatured } from './components/WeWereFeatured'
import { Reviews } from './components/Reviews'
import { FAQ } from './components/FAQ'
import { ReadyToFind } from './components/ReadyToFind'

export const FAQ_LIST = [
  {
    question: <>What is Nooklyn?</>,
    answer: (
      <>
        Nooklyn is a New York City–focused real estate platform that helps renters find apartments, rooms, and
        roommates. We also connect landlords and property managers with qualified tenants and provide tools to help make
        the renting process easier for everyone.
      </>
    ),
  },
  {
    question: <>What kind of documents do I need to apply with Nooklyn?</>,
    answer: (
      <>
        The documents you need are pretty standard:
        <ul>
          <li>A US Driver License or State ID or a passport for international tenants</li>
          <li>3 Recent Pay statements </li>
          <li>2 Recent Tax Statements</li>
          <li>3 Recent Bank Statements</li>
          <li>Proof of Past 12 Month Rental/Mortgage Payments</li>
          <li>Additional documents may be required depending on what is provided.</li>
        </ul>
      </>
    ),
  },
  {
    question: <>Does Nooklyn perform background or credit checks?</>,
    answer: (
      <>
        Yes, when you submit an application for a specific apartment, we use a third-party service called TenantAlert to
        run a credit check. This check is a soft inquiry and does not affect your credit score. We do not run background
        checks.
      </>
    ),
  },
  {
    question: <>I don’t have some of the above documents. What should I do?</>,
    answer: (
      <>
        Depending on the document there may be alternatives for example, some landlords allow for Corporate Guarantors
        such as TheGuarantors.com or Insurance. Please speak to your agent about alternative ways to get approved.
      </>
    ),
  },
  {
    question: <>Do I need to place a deposit to apply for an apartment?</>,
    answer: (
      <>
        Placing a deposit puts you first in line for that apartment. In NYC’s competitive apartment market, there are
        others interested in the same apartment as you, and a deposit gives you a priority period to get in your
        application for approval.
      </>
    ),
  },
  {
    question: <>Is my application transferable?</>,
    answer: <>Yes, speak to your agent about how to transfer your application to another apartment.</>,
  },
  {
    question: <>Is my deposit refundable?</>,
    answer: <>Yes, your deposit is fully refundable subtracting application fees as those are not refundable.</>,
  },
  {
    question: <>Can I apply with Nooklyn as an international?</>,
    answer: (
      <>
        Yes, you may need a corporate guarantor such as TheGuarantors.com but it is best to speak to an agent about your
        options.
      </>
    ),
  },
  {
    question: <>What is a guarantor and do I need one?</>,
    answer: (
      <>
        A guarantor is someone or a company that agrees to pay the landlord the rent if you cannot. Most commonly it is
        your parent or another relative who will pay on your behalf if needed. When it is a corporate guarantor, a
        company will charge you for this service. Most commonly, a property owner will request a guarantor if they
        believe there is too much risk associated with your application without a guarantor.
      </>
    ),
  },
]

export function HowItWorks({ signedIn }) {
  return (
    <>
      <Hero />
      <HowItWorksView />
      <WhyNooklyn />
      <NewestFeature />
      <WhoNooklynFor />
      <WeWereFeatured />
      <Reviews />
      <FAQ questions={FAQ_LIST} />
      <ReadyToFind signedIn={signedIn} />
    </>
  )
}
